import { getIndexedDB } from '@/dataSource/indexed-DB/indexedDB';
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Contact.vue'),
    children: [
      { path: '', name: 'ContactPage', component: () => import('@/components/Contact/index.vue') },
      { path: 'contact/:id/:name-:family', name: 'SelfContactPage', component: () => import('@/components/Contact/ShowSelfContact/Index.vue') },
      { path: 'contact/add', name: 'AddContactPage', component: () => import('@/components/Contact/AddContact/index.vue') },
      { path: 'contact/:id/edit', name: 'EditPageContact', component: () => import('@/components/Contact/editContact/index.vue') }
    ]

  },

  {
    path: '/place-phone', name: 'PlacePhone', component: () => import("@/views/PlacePhone.vue"),
    children: [
      { path: '', name: 'PlacePhonePage', component: () => import('@/components/PlacePhone/Index.vue'), },
      { path: 'add', name: 'AddPlacesPhone', component: () => import('@/components/PlacePhone/AddPlacePhone/Index.vue'), },
      { path: 'edit/:id', name: 'EditPlacePhone', component: () => import('@/components/PlacePhone/EditPlacePhone/Index.vue'), },

    ]
  },

  {
    path: '/notifications', name: 'Notifications', component: () => import("@/views/Notifications.vue"),
    children: [
      { path: '', name: 'NotificationsPage', component: () => import('@/components/Notification/Index.vue') },
      { path: 'show/:id', name: 'NotificationSelf', component: () => import('@/components/Notification/ShowSelfNotif/Index.vue') },
      { path: 'add/', name: 'NotificationAdd', component: () => import('@/components/Notification/AddNotif/Index.vue') },
      { path: 'edit/:id', name: 'NotificationEdit', component: () => import('@/components/Notification/EditNotifPage/Index.vue') },
    ]
  },

  {
    path: '/login',
    name: 'LoginPage',
    component: () => import('@/views/login.vue'),
    children: [
      { path: '', name: 'EnterNumberPage', component: () => import('@/components/Login/EnterNumber/index.vue') }
    ]
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  async function checkToken() {
    if (!await getIndexedDB('token')) {
      next({
        name: 'EnterNumberPage',
        replace: true
      })
    } else {
      next()
    }
  }
  if (to.name !== 'EnterNumberPage') {
    checkToken()
  } else {
    next()
  }
});
export default router

